import * as React from 'react';
import { Button } from './Filter.styles';
import type { FilterProps } from './Filter.types';

export const Filter = ({ onClick, name, active }: FilterProps): React.ReactElement<any> => (
  <Button onClick={onClick} active={active} name={name}>
    {name}
  </Button>
);
